<template>
  <v-row no-gutters align="start" justify="end">
    <v-col cols="6">
      <h5 class="secondary-font">{{ text }}</h5>
      <v-input v-model="model.value" :rules="rules"></v-input>
    </v-col>
    <v-col cols="6" class="d-flex justify-end">
      <v-btn-toggle
        v-model="model.value"
        class="bg-default"
        style="position: relative"
        :mandatory="model.value !== null"
      >
        <v-row no-gutters>
          <v-btn
            :value="false"
            active-class="error white--text"
            class="mr-3 text-capitalize secondary-font white"
            outlined
            small
            >Não</v-btn
          >
          <v-btn
            :value="true"
            active-class="success white--text"
            class="text-capitalize secondary-font white"
            outlined
            small
            >Sim</v-btn
          >
        </v-row>
      </v-btn-toggle>
    </v-col>
    <v-col cols="12" class="mt-2">
      <v-slide-y-transition>
        <v-text-field
          v-if="justify"
          v-show="model.value || (justifyAll && model.value === false)"
          v-model="model.text"
          label="Digite aqui"
          class="custom-textfield "
          solo
          flat
          dense
          hide-details
        ></v-text-field>
      </v-slide-y-transition>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    justify: {
      type: Boolean,
      default: false
    },
    justifyAll: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    rules() {
      if (!this.required) return [v => v !== null || 'Resposta obrigatória']
      return [v => (v !== null && !!this.model.text) || 'Resposta obrigatória']
    }
  }
}
</script>
